module.exports = __webpack_public_path__ + "static/media/bigPlus.ef1f41ba.svg";